module.exports = __webpack_public_path__ + "static/media/163b0acd-6114-4f85-818a-6485ffc4ad8e.cf77ea62.png";